import { Utilities } from "../../../../utils/utilities";
import { FirebaseInfoField } from "../../General/FirebaseInfoField";
import { LocalData } from "../../General/LocalData";
import { IncomeData } from "../Income/IncomeData";
import { AllTenantTypes } from "./TenantType";
import { UnitData } from "./UnitData";
import { UnitType } from "./UnitType";

export class UnitInfoFields {
  static loadFields(unit: UnitData, data: { [key: string]: any }) {
    for (const [key, infoField] of Object.entries(data)) {
      if (typeof infoField === "object" && infoField !== null) {
        const value = infoField.value;
        if (key === "type") {
          unit.type = new FirebaseInfoField(UnitType.getType(value), infoField);
        } else if (key === "tenantType" && typeof value === "string") {
          unit.tenantType = new FirebaseInfoField(
            AllTenantTypes.find((type) => type.id === value),
            infoField
          );
        } else if (key === "orgNumber" && typeof value === "string") {
          unit.orgNumber = new FirebaseInfoField(value, infoField);
        } else if (key === "floors" && Array.isArray(value)) {
          unit.floors = new FirebaseInfoField(value, infoField);
        } else if (key === "postAddress" && typeof value === "string") {
          unit.postAddress = new FirebaseInfoField(value, infoField);
        } else if (key === "area" && typeof value === "number") {
          unit.area = new FirebaseInfoField(value, infoField);
        } else if (key === "parkingSpots" && typeof value === "number") {
          unit.parkingSpots = new FirebaseInfoField(value, infoField);
        } else if (key === "snr" && typeof value === "string") {
          unit.snr = new FirebaseInfoField(value, infoField);
        } else if (key === "apartmentNumber" && typeof value === "string") {
          unit.apartmentNumber = new FirebaseInfoField(value, infoField);
        } else if (key === "streetNumber" && typeof value === "string") {
          unit.streetNumber = new FirebaseInfoField(value, infoField);
        } else if (key === "fireSafetyResponsibles" && Array.isArray(value)) {
          unit.fireSafetyResponsibles = new FirebaseInfoField(
            value.map((id) => LocalData.users.addData("" + id)),
            infoField
          );
        } else if (key === "contactInformation" && typeof value === "string") {
          unit.contactInformation = new FirebaseInfoField(value, infoField);
        } else if (key === "contactEmail" && typeof value === "string") {
          unit.contactEmail = new FirebaseInfoField(value, infoField);
        } else if (key === "contactPhone" && typeof value === "string") {
          unit.contactPhone = new FirebaseInfoField(value, infoField);
        } else if (key === "bedroomCount" && typeof value === "number") {
          unit.bedroomCount = new FirebaseInfoField(value, infoField);
        } else if (key === "furnitured" && typeof value === "boolean") {
          unit.furnitured = new FirebaseInfoField(value, infoField);
        } else if (key === "incomeData" && value && typeof value === "object" && value) {
          let incomeData = new IncomeData();
          incomeData.setup(value);
          unit.incomeData = new FirebaseInfoField(incomeData, infoField);
        } else if (key === "vatApplicable") {
          if (typeof value === "number") {
            unit.vatApplicable = new FirebaseInfoField(value, infoField);
          } else if (typeof value === "boolean") {
            unit.vatApplicable = new FirebaseInfoField(value ? 1 : 0, infoField);
          }
        } else if (key === "receivesEhfInvoice" && typeof value === "boolean") {
          unit.receivesEhfInvoice = new FirebaseInfoField(value, infoField);
        } else if (key === "contractConclusionDate") {
          unit.contractConclusionDate = new FirebaseInfoField(Utilities.getDateFromTimestamp(value), infoField);
        } else if (key === "contractStartDate") {
          unit.contractStartDate = new FirebaseInfoField(Utilities.getDateFromTimestamp(value), infoField);
        } else if (key === "contractEndDate") {
          unit.contractEndDate = new FirebaseInfoField(Utilities.getDateFromTimestamp(value), infoField);
        } else if (key === "runningRenewal" && typeof value === "number") {
          unit.runningRenewal = new FirebaseInfoField(value, infoField);
        } else if (key === "optionDuration" && typeof value === "number") {
          unit.optionDuration = new FirebaseInfoField(value, infoField);
        } else if (key === "optionDeadline") {
          unit.optionDeadline = new FirebaseInfoField(Utilities.getDateFromTimestamp(value), infoField);
        } else if (key === "optionNotification") {
          unit.optionNotification = new FirebaseInfoField(Utilities.getDateFromTimestamp(value), infoField);
        } else if (key === "indexRegulation" && typeof value === "object" && value) {
          unit.indexRegulation = new FirebaseInfoField(
            {
              active: typeof value.active === "boolean" ? value.active : false,
              percentage: typeof value.percentage === "number" ? value.percentage : undefined,
            },
            infoField
          );
        } else if (key === "fixedRegulation" && typeof value === "number") {
          unit.fixedRegulation = new FirebaseInfoField(value, infoField);
        } else if (key === "regulationInterval" && typeof value === "number") {
          unit.regulationInterval = new FirebaseInfoField(value, infoField);
        } else if (key === "lastRegulation") {
          unit.lastRegulation = new FirebaseInfoField(Utilities.getDateFromTimestamp(value), infoField);
        } else if (key === "jointArea" && typeof value === "object" && value) {
          unit.jointArea = new FirebaseInfoField(
            {
              type: typeof value.type === "string" ? value.type : undefined,
              value: typeof value.value === "number" ? value.value : undefined,
            },
            infoField
          );
        } else if (key === "guarantee" && typeof value === "string") {
          unit.guarantee = new FirebaseInfoField(value, infoField);
        } else if (key === "waterRent" && typeof value === "number") {
          unit.waterRent = new FirebaseInfoField(value, infoField);
        } else if (key === "electricityRent" && typeof value === "number") {
          unit.electricityRent = new FirebaseInfoField(value, infoField);
        } else if (key === "accountNumber" && typeof value === "string") {
          unit.accountNumber = new FirebaseInfoField(value, infoField);
        } else if (key === "marketRent" && typeof value === "number") {
          unit.marketRent = new FirebaseInfoField(value, infoField);
        } else if (key === "note" && typeof value === "string") {
          unit.note = new FirebaseInfoField(value, infoField);
        }
      }
    }
  }
}

